import settings from './settings/settings.routes';
import integrations from './settings/integrations/integrations.routes';
import subscription from './subscription/subscription.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import campaignsRoutes from './campaigns/campaigns.routes';
import { routes as captainRoutes } from './captain/captain.routes';
import { routes as pilotRoutes } from './pilot/pilot.routes';
import { routes as cannedRoutes } from './settings/canned/canned.routes';
import supportTicketsRoutes from './supportTickets/supportTickets.routes';
import AppContainer from './Dashboard.vue';
import Suspended from './suspended/Index.vue';
import NoAccounts from './noAccounts/Index.vue';
import Login from '../../components/auth/Login.vue';

export default {
  routes: [
    {
      path: '/app/phone-auth',
      name: 'phone_auth',
      component: Login,
    },
    {
      path: frontendURL('login'),
      name: 'login',
      component: Login,
      props: route => ({
        email: route.query.email,
        ssoAuthToken: route.query.sso_auth_token,
        ssoAccountId: route.query.sso_account_id,
      }),
    },
    {
      path: frontendURL('accounts/:accountId'),
      component: AppContainer,
      children: [
        ...captainRoutes,
        ...pilotRoutes,
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...integrations.routes,
        ...subscription.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...helpcenterRoutes.routes,
        ...cannedRoutes,
        ...campaignsRoutes.routes,
        ...supportTicketsRoutes.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
    {
      path: frontendURL('no-accounts'),
      name: 'no_accounts',
      component: NoAccounts,
    },
  ],
};
